import { productStatus } from "./productStatus";

export function productAlias(product: any, showCustomerId: boolean = true, showStatus: boolean = false): string {
  if(!product) return '';
  let productAlias = product.alias ? product.alias : product.fullName;
  if(showCustomerId && product.customerItemId) {
    productAlias = `${product.customerItemId} ${productAlias}`;
  }
  if(showStatus) {
    productAlias = `${productAlias} (${productStatus(product, false)})`;
  }
  return productAlias;
}